import Swiper from 'swiper/bundle'
import gsap from 'gsap'

import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function textWithImageSlider() {
    const textWithImageSliders = document.querySelectorAll(
        '.text-with-image-slider'
    )

    if (textWithImageSliders.length > 0) {
        textWithImageSliders.forEach((textWithImageSlider, index) => {
            function initializeSwiper() {
                const slider = textWithImageSlider.querySelector(
                    '[data-target="slider"]'
                )
                const slides =
                    textWithImageSlider.querySelectorAll('.swiper-slide')

                // SET UP SLIDER
                const slidesLength = slides.length
                const slideNext = textWithImageSlider.querySelector(
                    '.text-with-image-slider-button-next'
                )
                const slidePrev = textWithImageSlider.querySelector(
                    '.text-with-image-slider-button-prev'
                )

                let swiper

                swiper = new Swiper(slider, {
                    slidesPerView: 'auto',
                    spaceBetween: -135,
                    loop: true,
                    navigation: {
                        nextEl: slideNext,
                        prevEl: slidePrev,
                    },
                    autoplay: {
                        delay: 3500,
                        pauseOnMouseEnter: true,
                    },
                    breakpoints: {
                        1500: {
                            spaceBetween: -218,
                        },
                        1280: {
                            spaceBetween: -232,
                        },
                        1115: {
                            spaceBetween: -123,
                        },
                        1024: {
                            spaceBetween: -125,
                        },
                        768: {
                            spaceBetween: -165,
                        },
                    },
                }).on('slideChange', () => {
                    let prev = swiper.realIndex - 1
                    const active = swiper.realIndex
                    let next = (swiper.realIndex + 1) % slidesLength
                    let next2 = (next + 1) % slidesLength
                    let next3 = (next + 2) % slidesLength

                    slides.forEach((slide, index) => {
                        if (index === active) {
                            slides[index].style.zIndex = 10
                            gsap.to(slides[index], {
                                scale: 1,
                                autoAlpha: 1,
                                duration: 0.3,
                            })
                        } else if (index === next) {
                            slides[index].style.zIndex = 5
                            gsap.to(slides[index], {
                                scale: 0.95,
                                autoAlpha: 1,
                                duration: 0.3,
                            })
                        } else if (index === next2) {
                            slides[index].style.zIndex = 4
                            gsap.to(slides[index], {
                                scale: 0.9,
                                autoAlpha: 1,
                                duration: 0.3,
                            })
                        } else if (index === next3) {
                            slides[index].style.zIndex = 3
                            gsap.to(slides[index], {
                                scale: 0.85,
                                autoAlpha: 1,
                                duration: 0.3,
                            })
                        } else {
                            slides[index].style.zIndex = 1
                            gsap.to(slides[index], {
                                scale: 0.8,
                                autoAlpha: 0,
                                duration: 0.3,
                            })
                        }
                    })
                })

                swiper.autoplay.stop()

                if (window.innerWidth > 1114) {
                    swiper.autoplay.start()
                }
            }

            /**
             *      POPUPS
             */

            function initPopups() {
                const popups = document.querySelectorAll(
                    '[data-target="popup"]'
                )
                const slidesWithPopup = document.querySelectorAll(
                    '[data-target="has-popup"]'
                )

                if (popups) {
                    const popupOverlay = document.querySelectorAll(
                        '[data-target="overlay"]'
                    )
                    slidesWithPopup.forEach((slide, index) => {
                        const popupContent = document.querySelectorAll(
                            '[data-target="popup-content"]'
                        )
                        const href = slide.querySelector('a')
                        const closeBtn = document.querySelectorAll(
                            '[data-target="close-button"]'
                        )

                        href.addEventListener('click', (e) => {
                            e.preventDefault()
                        })

                        gsap.set(popupOverlay, { autoAlpha: 0 })
                        gsap.set(popupContent, { autoAlpha: 0, xPercent: 100 })
                        gsap.set(popups, { pointerEvents: 'none' })

                        slide.addEventListener('click', (e) => {
                            gsap.to(popupOverlay[index], {
                                autoAlpha: 1,
                                duration: 0.3,
                            })
                            gsap.to(popupContent[index], {
                                autoAlpha: 1,
                                xPercent: 0,
                                duration: 0.3,
                            })
                            gsap.set(popups[index], { pointerEvents: 'all' })
                            gsap.set(document.body, { overflow: 'hidden' })
                            gsap.set(document.documentElement, {
                                overflowY: 'hidden',
                            })
                            gsap.set(popups[index], { position: 'fixed' })
                        })

                        popupOverlay[index].addEventListener(
                            'click',
                            (e) => {
                                gsap.to(popupOverlay[index], {
                                    autoAlpha: 0,
                                    duration: 0.3,
                                })
                                gsap.to(popupContent[index], {
                                    autoAlpha: 0,
                                    xPercent: 100,
                                    duration: 0.3,
                                    onComplete: () => {
                                        gsap.set(popups[index], {
                                            position: 'absolute',
                                        })
                                    },
                                })
                                gsap.set(popups, { pointerEvents: 'none' })
                                gsap.set(document.body, { overflowY: 'auto' })
                                gsap.set(document.documentElement, {
                                    overflowY: 'auto',
                                })
                            },
                            false
                        )

                        closeBtn.forEach((btn) => {
                            btn.addEventListener(
                                'click',
                                (e) => {
                                    gsap.to(popupOverlay[index], {
                                        autoAlpha: 0,
                                        duration: 0.3,
                                    })
                                    gsap.to(popupContent[index], {
                                        autoAlpha: 0,
                                        xPercent: 100,
                                        duration: 0.3,
                                    })
                                    gsap.set(popups, { pointerEvents: 'none' })
                                    gsap.set(document.body, {
                                        overflowY: 'auto',
                                    })
                                    gsap.set(document.documentElement, {
                                        overflowY: 'auto',
                                    })
                                },
                                false
                            )
                        })
                    })
                }
            }

            initializeSwiper()
            window.addEventListener('resize', initializeSwiper)
            initPopups()
        })
    }
}

export default textWithImageSlider
